import axios from "axios";

export const baseURL = process.env.REACT_APP_BASE_URL;
const apiClient = axios.create({
  baseURL: baseURL,
});

function initializeApiClient() {
  let authToken =
    localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
  if (authToken && authToken !== "null" && authToken !== "undefined") {
    apiClient.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;
  } else {
    localStorage.removeItem("authToken");
    sessionStorage.removeItem("authToken");
    delete apiClient.defaults.headers.common["Authorization"];
  }
}

function setAuthToken(token) {
  if (token && token !== "null" && token !== "undefined") {
    apiClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete apiClient.defaults.headers.common["Authorization"];
  }
}

initializeApiClient();

export { setAuthToken, initializeApiClient };
export default apiClient;
